import { useFormikContext } from "formik";
import type { OnboardingValues } from "@/features/portal/components/onboarding/wizard-schema";

export interface TabProps {
  /** Autosave a single field's current value (blur or select-commit). */
  save: (name: string, value: unknown) => void;
}

/**
 * Returns a curried `onBlur` factory that autosaves the field's current Formik
 * value — `onBlur={onBlur("first_name")}`. Reads live values from context so
 * every tab shares one autosave path.
 */
export function useBlurSave(save: TabProps["save"]) {
  const { values } = useFormikContext<OnboardingValues>();
  return (name: keyof OnboardingValues) => () => save(name as string, values[name]);
}
